import { setCookie, getCookie } from '../base/_utilities';

const marketing_modal_element = document.getElementById('apm-marketing-dialog');
const exit_modal_element = document.getElementById('apm-exit-dialog');

let modalHasExecuted = false;
let cookieScriptExists = false;


/**
 *
 *
 *
 */
const init = function() {

  // Before the marketing modal is displayed we'll wait until the user
  // has accepted cookies and has accepted the functionality category
  // of cookies - relies on CookieScript integration which is included
  // via Google Tag Manager
  window.addEventListener( 'CookieScriptAccept', function(e) {
    cookieScriptExists = true;    
    if ( e.detail.categories && e.detail.categories.includes('functionality') ) {
      setup_marketing_modal();
    }
  })

  window.addEventListener( 'CookieScriptLoaded', function() {
    cookieScriptExists = true;
    if ( CookieScript.instance.dispatchEventNames.includes('CookieScriptCategory-functionality') ) {
			setup_marketing_modal();
    }
  });

  // If after 3 seconds cookie-script hasn't done anything we'll
  // initialize the modal check and use default modal behavior
  setTimeout( () => {
    if ( !cookieScriptExists ) {
      setup_marketing_modal();
    }
  }, 3000 );

	setup_exit_modal();

};


const weCanUseCookies = function() {

  if ( !cookieScriptExists ) {
    return true;
  }

  if ( typeof CookieScript.instance.dispatchEventNames !== 'undefined' ) {
    if ( CookieScript.instance.dispatchEventNames.includes('CookieScriptCategory-functionality') ) {
      return true;
    }
  }

  return false;

}


/**
 * 
 * 
 * 
 */
const setup_marketing_modal = function() {

	if ( marketing_modal_element !== null && !modalHasExecuted ) {

    modalHasExecuted = true;

		const cookieDuration = ( marketing_modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) ) ? marketing_modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) : 0;
		const cookieName		 = ( marketing_modal_element.getAttribute( 'data-apm-modal-cookie-id' ) ) ? marketing_modal_element.getAttribute( 'data-apm-modal-cookie-id' ) : '';
		const modalViewed	 	 = getCookie( cookieName );

		// Instantiate a new A11yDialog module
		const dialog = new A11yDialog(marketing_modal_element);

		if ( !modalViewed ) {
			dialog.show()
      if ( weCanUseCookies() ) {
        setCookie(cookieName, true, cookieDuration)
      }
		}

	}

}


/**
 * 
 * 
 * 
 */
const setup_exit_modal = function() {

	if ( exit_modal_element !== null ) {

		const dialogCancel = document.getElementById('exit_modal_cancel');
		const dialogButton = document.getElementById('exit_modal_link');
		const dialog = new A11yDialog( exit_modal_element );
		const pageLinks = document.getElementById('main').querySelectorAll('a');
		const urlData = exit_modal_element.getAttribute('data-dialog-exit-urls');
		const urls = JSON.parse(urlData);

		if ( dialogButton ) {
			dialogButton.addEventListener( 'click', () => {
				dialog.hide();
			} );
		}

		if ( dialogCancel ) {
			dialogCancel.addEventListener( 'click', () => {
				dialog.hide();
			} );
		}

		if ( pageLinks && dialogButton && urls ) {

			// console.log( pageLinks );

			// loop through each page link to compare against
			// the protected URL array
			pageLinks.forEach( ( pageLink ) => {

				// watch all page links (within #main)
				pageLink.addEventListener( 'click', ( event ) => {
				
					// make sure we have a host value to work with
					if ( event.target.href ) {

						const targetHref = event.target.href;
						const linkTarget = event.target.getAttribute('target');
						const linkRel 	 = event.target.getAttribute('rel');

						// look through the admin-defined urls to see if the
						// host name is present. If so, prevent the default
						// link action and show the exit confirmation modal
						urls.forEach( ( url ) => {
							if ( targetHref.includes( url.url, 0 ) ) {
								event.preventDefault();

								// set modal button attributes
								dialogButton.setAttribute( 'href', targetHref );
								if ( linkTarget ) dialogButton.setAttribute( 'target', linkTarget);
								if ( linkRel ) dialogButton.setAttribute( 'rel', linkRel );

								// show the modal
								dialog.show();
							}
						} );
					}
				} )
			} );

		}
	}
}



const api = {
	init: init
};

export default api;